module.exports = __webpack_public_path__ + "static/media/webdesign-services-img67.06a0132a.jpg";